import { IonCol, IonIcon, IonText } from "@ionic/react";
import classNames from "classnames/bind";
import { basketOutline } from "ionicons/icons";
import React from "react";
import { Product } from "@core/types";
import styles from "./NewListViewProduct.module.scss";
import { useProductCardActions } from "../../../../../providers/useProductActions";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

interface BasketIconProps {
  product: Product;
}

const BasketIcon = ({ product }: BasketIconProps) => {
  const { addToCart, showProductDetail } = useProductCardActions();
  const { t } = useTranslation();
  return (
    <IonCol
      size="12"
      className={cx("ion-text-right ion-no-padding", { disabled: !product?.purchasable })}
      onClick={(e) => {
        product.stockQuantity > 0 ? addToCart(product) : showProductDetail(product.id);
        e.stopPropagation();
      }}
    >
      {product.stockStatus === "instock" ? (
        <IonIcon icon={basketOutline} className={cx("productBasketIcon !bg-transparent !text-primary")} />
      ) : (
        <IonText className={cx("out-of-stock")}>{t("Out of Stock")}</IonText>
      )}
    </IonCol>
  );
};

export default BasketIcon;
